import React, { useState, useCallback, useEffect, Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";

//import Auth from "./user/pages/Auth";
//import LandingPage from "./user/pages/LandingPage";
//import NewPlace from "./jobs/pages/NewPlace";
//import Jobs from "./jobs/pages/Jobs";
//import UpdatePlace from "./jobs/pages/UpdatePlace";
import MainNavigation from "./shared/components/Navigation/MainNavigation";
import LoadingSpinner from "./shared/components/UIElements/LoadingSpinner";
import { AuthContext } from "./shared/context/auth-context";
import { useAuth } from './shared/hooks/auth-hook';
//import UserDashboard from "./user/pages/UserDashboard";
//import CompanyPage from "./company/pages/CompanyPage";

const Auth = React.lazy(() => import("./user/pages/Auth"));
const LandingPage = React.lazy(() => import("./user/pages/LandingPage"));
const NewPlace = React.lazy(() => import("./jobs/pages/NewPlace"));
const Jobs = React.lazy(() => import("./jobs/pages/Jobs"));
const UpdatePlace = React.lazy(() => import("./jobs/pages/UpdatePlace"));
const CompanyPage = React.lazy(() => import("./company/pages/CompanyPage"));
const CompanyDashboard = React.lazy(() => import("./company/pages/CompanyDashboard"));
const UserDashboard = React.lazy(() => import("./user/pages/UserDashboard"));


const App = () => {

  const [isModalOpened, setIsModalOpened] = useState(false);
  const [isFilterModalOpened, setIsFilterModalOpened] = useState(false);
  const [isMapModalOpened, setIsMapModalOpened] = useState(false);
  const [isJobOfferOpened, setIsJobOfferOpened] = useState(false);
  const [isJobPopupOpened, setIsJobPopupOpened] = useState(false);
  const [isJobModalOpened, setIsJobModalOpened] = useState(false);
  const [jobProps, setJobProps] = useState(false);

  const { token, login, logout, userId, type, isLoggedIn } = useAuth();

  const defineJobProps = (jobProperties) => {
    setJobProps(jobProperties);
    console.log("jobProperties" + jobProperties);
  };

  const toggleModal = useCallback(() => {
    setIsModalOpened((prevState) => !prevState);
  }, []);

  const toggleFilterModal = useCallback(() => {
    setIsFilterModalOpened((prevState) => !prevState);
  });

  const toggleMapModal = useCallback(() => {
    setIsMapModalOpened((prevState) => !prevState);
  });

  const toggleJobModal = useCallback(() => {
    setIsJobModalOpened((prevState) => !prevState);
  });

  const toggleJobOfferModal = useCallback(() => {
    setIsJobOfferOpened((prevState) => !prevState);
  })

  const toggleJobPopupModal = useCallback(() => {
    setIsJobPopupOpened((prevState) => !prevState);
  })

  let routes;
  if (token) {
    if (type === "company") {
      routes = (
        <Switch>
          <Route path="/company/dashboard" exact>
            <CompanyDashboard />
          </Route>
          <Redirect to="/company/dashboard" />
        </Switch>
      );
    }
    else if (type === "user") {
      routes = (
        <Switch>
          <Route path="/" exact>
            <LandingPage />
          </Route>
          <Route path="/feed/:searchInput" exact>
            <Jobs />
          </Route>
          <Route path="/places/new" exact>
            <NewPlace />
          </Route>
          <Route path="/users/dashboard" exact>
            <UserDashboard />
          </Route>
          <Route path="/places/:placeId">
            <UpdatePlace />
          </Route>
          <Redirect to="/" />
        </Switch>
      );
    }
  } else {
    routes = (
      <Switch>
        <Route path="/" exact>
          <LandingPage />
        </Route>
        <Route path="/company" exact>
          <CompanyPage />
        </Route>
        <Route path="/feed/:searchInput" >
          <Jobs />
        </Route>
        <Redirect to="/" />
      </Switch>
    );
  }

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: !!token,
        token: token,
        userId: userId,
        type: type,
        isModalOpened: isModalOpened,
        jobProps: jobProps,
        login: login,
        logout: logout,
        toggleModal: toggleModal,
        isFilterModalOpened: isFilterModalOpened,
        isJobModalOpened: isJobModalOpened,
        toggleFilterModal: toggleFilterModal,
        isMapModalOpened: isMapModalOpened,
        toggleMapModal: toggleMapModal,
        isJobOfferOpened: isJobOfferOpened,
        toggleJobOfferModal: toggleJobOfferModal,
        isJobPopupOpened: isJobPopupOpened,
        toggleJobPopupModal: toggleJobPopupModal,
        toggleJobModal: toggleJobModal,
        defineJobProps: defineJobProps
      }}
    >
      <Router>
        <MainNavigation />
        <main><Suspense fallback={
          <div className="center">
            <LoadingSpinner />
          </div>
        }>{routes}</Suspense></main>
      </Router>
    </AuthContext.Provider>
  );
};

export default App;
